import {codeInputCommonAttrs, ColumnTypes} from '../constants'
import { ModelDef } from '../index'

/**
 * importableModelで作成可能なColumnType
 */
const selectableColumnTypes = [
  ColumnTypes.String,
  ColumnTypes.Text,
  ColumnTypes.RichText,
  ColumnTypes.Number,
  ColumnTypes.DateOnly,
  ColumnTypes.Boolean,
  ColumnTypes.File,
  ColumnTypes.Select,
  ColumnTypes.MultiSelect,
  ColumnTypes.Reference,
]

/**
 * selectableOptionsを指定可能なColumnType
 */
const enableSelectOptionsColumnTypes = [ColumnTypes.String, ColumnTypes.MultiSelect, ColumnTypes.Select]

/**
 * tableName validator
 */
const validateTableName = (value, col, modelName, record) => {

}

const importableModels: ModelDef = {
  tableName: 'importableModels',
  tableLabel: '追加Model定義',
  tableComment: '',
  timestamps: true,
  useAlgolia: false,
  defaultSort: { key: 'tableName', order: 'asc' },
  columns: {
    tableName: {
      label: 'テーブル名',
      type: ColumnTypes.String,
      validate: {
        notEmpty: true, tableName: (value, col, modelName, record) => {

        }
      },
      searchable: true,
      editable: false,
      editableOnCreate: true,
      unique: true,
    },
    tableLabel: {
      label: 'table label',
      type: ColumnTypes.String,
      validate: { notEmpty: true },
      searchable: true,
      editable: false,
      editableOnCreate: true,
    },
    tableComment: {
      label: 'テーブル説明',
      type: ColumnTypes.Text,
    },
    editable: {
      label: '編集可能',
      type: ColumnTypes.Boolean,
      default: true,
    },
    deletable: {
      label: '削除可能',
      type: ColumnTypes.Boolean,
      default: true,
    },
    timestamp: {
      label: '作成/変更日時の自動追加',
      type: ColumnTypes.Boolean,
      default: true,
    },
    showOnMainmenu: {
      type: ColumnTypes.Boolean,
      label: 'メインメニューに表示',
    },
    showOnSettingMenu: {
      type: ColumnTypes.Boolean,
      label: 'セッティングメニューに表示',
    },
    defaultSort_key: {
      type: ColumnTypes.String,
      label: '並べ替え(key)',
      comment: 'カラム定義のkeyを指定',
    },
    defaultSort_order: {
      type: ColumnTypes.Select,
      label: '並べ替え順',
      selections: () => ['asc', 'desc'],
    },
    bulkControllable: {
      type: ColumnTypes.Boolean,
      label: '一括編集可能',
      default: true,
    },
    useBeforeSaveFunction: {
      type: ColumnTypes.Boolean,
      label: 'beforeSave() 処理を利用',
    },
    beforeSaveFunctionDef: {
      label: 'beforeSave() 処理',
      inputHelpText: `async beforeSave(row, beforeData) {..., return row} の文脈で実行されます。rowのプロパティを書き換えて下さい。beforeData はnullである場合があります。`,
      type: ColumnTypes.Text,
      inputAttrs: {
        ...codeInputCommonAttrs,
        placeholder: "if (!row.id) {\n  row.id = md5(row.some + '--' + row.another)\n}",
      },
      enableIf: (row) => !!row.useBeforeSaveFunction
    },
    otherModelAttributes: {
      type: ColumnTypes.Text,
      label: 'JS形式のモデルの追加属性定義',
      inputHelpText: 'オブジェクト形式で記述。Javascriptの記法を利用可能で、他属性を上書きすることが可能です。(editCallbackなどで利用する)',
      inputAttrs: {
        ...codeInputCommonAttrs
      }
    },
    columns: {
      label: 'カラム定義',
      type: ColumnTypes.ArrayOfObject,
      inputAttrs: { wrapperClass: 'col-12' },
      visibleOnIndex: false,
      columns: {
        key: {
          type: ColumnTypes.String,
          validate: { notEmpty: true },
          comment: '実データのキーを定義します',
          label: 'キー',
        },
        label: {
          type: ColumnTypes.String,
        },
        type: {
          type: ColumnTypes.Select,
          validate: { notEmpty: true },
          selections() {
            return selectableColumnTypes
          },
        },
        default: {
          type: ColumnTypes.String,
          label: 'デフォルト値',
          enableIf: (row) => row.type !== ColumnTypes.ArrayOfObject,
        },
        // defaultNumber: {
        //   type: ColumnTypes.Number,
        //   label: 'デフォルト値',
        //   enableIf: (row) => row.type === ColumnTypes.Number,
        // },
        unique: {
          type: ColumnTypes.Boolean,
          label: '重複禁止',
          comment: '同じ値を登録できないようにします。'
        },
        visible: {
          type: ColumnTypes.Boolean,
          label: '表示する',
          comment: '表側では非表示にして、裏側で値を保持するときに利用します。',
          default: true,
        },
        visibleOnIndex: {
          type: ColumnTypes.Boolean,
          label: '一覧画面で表示をする',
          default: true,
        },
        editable: {
          type: ColumnTypes.Boolean,
          label: '編集可能',
          default: true,
          comment: 'チェックを外すと、編集できなくなります。自動算出フィールド等で利用します。'
        },
        editableOnCreate: {
          type: ColumnTypes.Boolean,
          enableIf: (row, child) => !row.editable,
          label: '新規作成時のみ編集可能',
          default: false,
        },
        referenceOfStore_storeName: {
          type: ColumnTypes.String,
          label: '参照Model',
          validate: { notEmpty: true },
          enableIf: (row) => row.type === ColumnTypes.Reference,
        },
        referenceOfStore_key: {
          type: ColumnTypes.String,
          label: '参照Key',
          validate: { notEmpty: true },
          enableIf: (row) => row.type === ColumnTypes.Reference,
        },
        referenceOfStore_label: {
          type: ColumnTypes.String,
          label: '参照Label',
          validate: { notEmpty: true },
          enableIf: (row) => row.type === ColumnTypes.Reference,
        },
        selectionsWithSelectOptionsMasterGroupName: {
          type: ColumnTypes.String,
          async selections($store, record, currentValue, initialValue) {
            return window.$nuxt.$models.selectOptionsMaster.fetchFacetNamesByColName('group')
          },
          label: '選択肢マスタ指定',
          enableIf: (row) => enableSelectOptionsColumnTypes.includes(row.type),
        },
        createSelectOptionsMasterOnAddNewSelection: {
          type: ColumnTypes.Boolean,
          label: '新規選択肢を自動登録する',
          enableIf: (row) => enableSelectOptionsColumnTypes.includes(row.type),
        },
        additionalSelectOptions_prepend: {
          type: ColumnTypes.MultiSelect,
          label: '選択肢を前方に追加',
          enableIf: (row) => enableSelectOptionsColumnTypes.includes(row.type),
        },
        additionalSelectOptions_append: {
          type: ColumnTypes.MultiSelect,
          label: '選択肢を後方に追加',
          enableIf: (row) => enableSelectOptionsColumnTypes.includes(row.type),
        },
        // dynamicSelections: {
        //   type: ColumnTypes.Boolean,
        //   label: '選択肢の内容を再計算する',
        // },
        // selectionsWithAlgoFacetsColName: {
        //   type: ColumnTypes.Boolean,
        // },
        validate_notEmpty: {
          type: ColumnTypes.Boolean,
          label: '入力必須',
        },
        validate_min: {
          type: ColumnTypes.Number,
          label: '最小値',
          enableIf: (row) => row.type === ColumnTypes.Number,
        },
        validate_max: {
          type: ColumnTypes.Number,
          label: '最大値',
          enableIf: (row) => row.type === ColumnTypes.Number,
        },
        facet_showOnSearch: {
          type: ColumnTypes.Boolean,
          label: '絞り込み可能なリストとして'
        },
        searchable: {
          type: ColumnTypes.Boolean,
          label: '検索可',
        },
        groupedEdit: {
          type: ColumnTypes.Boolean,
        },
        inputAttrs_prefix: {
          label: '接頭語(prefix)',
          type: 'STRING',
          comment: 'フィールドに接頭語を付与します。単位などで利用します。 (例: KG)'
        },
        inputAttrs_suffix: {
          label: '接尾語(suffix)',
          type: 'STRING',
          comment: 'フィールドに接尾語を付与します。単位などで利用します。 (例: KG)'
        },
        inputHelpText: {
          label: '入力欄説明文',
          type: ColumnTypes.Text,
          inputAttrs: {
            wrapperClass: 'col-12',
          },
          inputHelpText: '※ このテキストのことです。'
        },
        inputAttrs: {
          label: '',
          type: ColumnTypes.Text,
          comment: 'JSONで記述(load時にparseされます)',
        },
        otherColAttributes: {
          type: ColumnTypes.Text,
          label: 'JS形式の追加カラム定義',
          inputHelpText: 'オブジェクト形式で記述。Javascriptの記法を利用可能で、他属性を上書きすることが可能です。(editCallbackや、enableIf などで利用する)',
          inputAttrs: {
            ...codeInputCommonAttrs,
            placeholder: ``
          }
        },
      },
    },
  },
  showOnMainmenu: false,
  showOnSettingMenu: false,
  shouldCreateHistoryData: ({ before, after }) => false,
  afterSave: async (saved: any, oldData: any): Promise<boolean> => {
    // await loadImportableModelDefinedModelsIntoModelObjects()
    return true
  },
}

export default importableModels
